<template>
  <div class="com-box">
    <div class="com-title" v-if="!isDistributor">仅限各办事处市场经理使用</div>
    <div class="com-content title-box">
      <van-form 
        :show-error-message="false" 
        validate-trigger="onSubmit" 
        validate-first
        ref="form"
      >
        <van-field
          class="text-input"
          required
          readonly
          v-model="reportForms"
          label="报表类型"
          placeholder="请选择"
          :rules="[{ required: true, message: '请选择报表类型' }]"
          @click="isReportForms = true"
        >
          <van-icon name="arrow" slot="right-icon" class="input-right-icon" />
        </van-field>
        <template v-if="!isDistributor && !isShopowner && form.type != 5">
          <template  v-if="form.type != 2 && form.type != 6">
            <van-field
              class="text-input"
              readonly
              v-model="form.startTime"
              label="开始时间"
              placeholder="请选择开始时间"
              @click="selectTime('startTime')"
            >
             <van-icon name="arrow" slot="right-icon" class="input-right-icon" />
            </van-field>
            <van-field
              class="text-input"
              readonly
              v-model="form.endTime"
              label="结束时间"
              placeholder="请选择结束时间"
               @click="selectTime('endTime')"
            >
             <van-icon name="arrow" slot="right-icon" class="input-right-icon" />
            </van-field>
          </template>
          <van-field
            class="text-input"
            required
            v-model="form.extractionCode"
            label="提取码"
            :rules="[{ required: true, message: '请输入提取码' }]"
            placeholder="请输入提取码"
          >
          </van-field>
          <van-field
            v-if="!isTeacher"
            class="text-input"
            required
            readonly
            v-model="dataRange"
            label="数据范围"
            placeholder="请选择"
            :rules="[{ required: true, message: '请选择数据范围' }]"
            @click="isDataRange = true"
          >
            <van-icon name="arrow" slot="right-icon" class="input-right-icon" />
          </van-field>
        </template>
        <van-field
          v-if="form.type == 5"
          class="text-input"
          required
          readonly
          v-model="form.activityId"
          label="活动id"
          placeholder="请选择"
          :rules="[{ required: true, message: '请选择活动id' }]"
          @click="isActivityId = true"
        >
          <van-icon name="arrow" slot="right-icon" class="input-right-icon" />
        </van-field>
      </van-form>
    </div>
    <div class="downBtn">
      <van-button  type="primary" color="#FF6B31" @click="downloadClick">下载</van-button>
    </div>
    <van-action-sheet v-model="isReportForms" :actions="actions" @select="onSelect" />
    <van-popup v-model="isDataRange" position="bottom">
      <van-picker
        title="数据范围选择"
        show-toolbar
        value-key="name"
        :columns="columns"
        @confirm="onConfirm"
        @cancel="isDataRange = false"
      />
    </van-popup>
    <van-popup v-model="isTimePop" position="bottom" get-container="body">
      <van-datetime-picker
        v-model="currentDate"
        type="datetime"
        title="选择时间"
        :min-date="minDate"
        @cancel="isTimePop = false"
        @confirm="timeConfirm"
      />
    </van-popup>
    <van-popup v-model="isActivityId" position="bottom">
      <van-picker
        title="活动id选择"
        show-toolbar
        :columns="activityIdArr"
        @confirm="changeId"
        @cancel="isActivityId = false"
      />
    </van-popup>
  </div>
</template>
<script>
import moment from "moment";
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters([
      'isTeacher',
      'isDistributor',
      'isShopowner',
      'isGuide',
      'userInfo'
    ]),
  },
  data() {
    return {
      actions: [],
      isReportForms: false,
      reportForms: "",
      isDataRange: false,
      dataRange: "所有数据",
      columns: [{name: '所有数据', activityId: ''}],
      minDate: new Date(2021, 1, 1),
      defaultDateRange: [],
      //活动id选择
      isActivityId: false,
      activityIdArr: [],
      form: {
        extractionCode: "",
        startTime: "",
        endTime: "",
        type: 1,
        activityId: ''
      },
      isClick: true,
      isTimePop: false,
      currentDate: new Date(2024, 1, 1),
      timeFiled: 'startTime'
    };
  },
  mounted() {
    if (this.isTeacher) {
      this.actions = [
        { name: '拉新/报名',type: 1 },
        { name: '认证名单', type: 2 },
        { name: '报名明细', type: 3 },
        { name: '门店活动数据', type: 4 },
        { name: '营销活动资金明细', type: 5},
        { name: '经销商钱包余额', type: 6 },
      ]
    }else if (this.isShopowner) {
      this.actions = [
        { name: '报名明细（门店）',type: 9},
        { name: '营销活动资金明细', type: 5}
      ]
    }else if (this.isDistributor) {
      this.actions = [
        { name: '报名明细（经销商）',type: 8},
        { name: '营销活动资金明细', type: 5}
      ]
    }
    this.selectActivityList()
  },
  methods: {
    onSelect(obj) {
      this.reportForms = obj.name
      this.form.type = obj.type
      this.isReportForms = false
    },
    // 时间选择
    selectTime(filed) {
      this.currentDate = this.form[filed] ? new Date(this.form[filed]) : new Date()
      this.timeFiled = filed
      this.isTimePop = true
    },
    timeConfirm(time) {
      this.form[this.timeFiled] = moment(time).format("YYYY-MM-DD HH:mm:ss")
      this.isTimePop = false
    },

    // 数据范围选择
    onConfirm(e) {
      this.form.activityId = e.activityId
      this.dataRange = e.name
      this.isDataRange = false
    },
    // 活动id选择
    changeId(id) {
      this.form.activityId = id
      this.isActivityId = false
    },
    // 查询活动id
    selectActivityList() {
      this.$api.activityMgmt.selectActivityList()
        .then(res => {
          this.activityIdArr = res.data
        })
    },
    // 下载
    downloadClick() {
      this.$refs.form.validate().then(res => {
        if (this.isShopowner) { // 店长
          this.form.storeCode =  this.userInfo.storeCode
        }else if (this.isDistributor){ // 经销商
          this.form.cusId = this.userInfo.customerId
        }
        this.download()
      }).catch(err => {
        this.$toast(err[0].message);
      })
    },
    download() {
      if (this.isClick){
        this.isClick = false
        return this.$api.activityMgmt
          .dataExport(this.form)
          .then((res) => {
            if (res.success) {
              this.$dialog.confirm({
                title: '下载提示',
                message:`因数据较大正在处理中，请稍后到<br/>我的-导出列表中下载数据`,
                cancelButtonText: '确定',
                confirmButtonText: '去往-导出列表'
              }).then(_ =>{
                this.$router.push({
                  path: '/export-list'
                })
              })
            }
          }).finally(_ => {
            setTimeout(() => {
              this.isClick = true
            },500)
          })
      }
    },
    // 二进制流文件下载
    downloadFile(fileUrl, fileName) {
      const link = document.createElement("a");
      link.style.display = "none";
      link.href = fileUrl;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    exportClick() {
      this.$router.push({
        path: '/export-list',
      })
    },
  },
};
</script>

<style lang="stylus" scoped>
.com-box
  .com-title
    padding 15px
    font-size 14px
    font-weight bold
    color #303133
    text-align: center
  .com-content
    margin 10px 15px
    padding 15px 15px 5px
    background-color: #fff
    border-radius: 8px

    .text-input
      padding 10px 7px
      >>> .van-field__body input
        color $mainTextColor
      &::before
        left -2px
        bottom 7px

  .title-box
    padding 0 15px
 .van-button--normal
   padding:0px  40px
 .van-button--primary
   background-color #1989fa
   border: 1px solid #1989fa
 .downBtn
   width 100%
   height 100px
   text-align center
   margin-top 20%
   .export {
    margin-left: 10px;
   }
</style>
